import React from 'react';
import App from '../components/App/App';
import adminGroupedOrders from './admin/groupedorder';
import adminGroupedOrderCreate from './admin/groupedorder/create';
import adminPartnerAccounts from './admin/partneraccount';
import adminUsersManagement from './admin/user/index';
import calendar from './calendar';
import almanac from './content/almanac';
import articleList from './content/article';
import dailyNews from './content/dailynews';
import emag from './content/emag';
import fictions from './content/fictions';
import manager from './content/manager';
import notifications from './content/notification';
import space from './content/partnerspace';
import quiz from './content/quiz';
import fleetList from './fleet';
import fleetInfo from './fleet/info';
import home from './home';
import partnerProfile from './partner';
import profile from './profile';
import statistics from './statistics';
import usersManagement from './user/index';
import { ApolloClient } from '@apollo/client';
import { RouteContext } from 'universal-router';
import ContextProviders from './ContextProviders';

const getRoutes = (apolloClient: ApolloClient) => [
  {
    path: '/resetPassword/:token',
    async action(context: RouteContext) {
      const { default: Reset } = await import('./reset/Reset');
      return (
        <ContextProviders apolloClient={apolloClient} context={context}>
          <App context={context} resetPassword={true}>
            <Reset token={context.params.token} create={false} />
          </App>
        </ContextProviders>
      );
    },
  },
  {
    path: '/createPassword/:token',
    async action(context: RouteContext) {
      const { default: Reset } = await import('./reset/Reset');
      return (
        <ContextProviders apolloClient={apolloClient} context={context}>
          <App context={context} resetPassword={true}>
            <Reset token={context.params.token} create={true} />
          </App>
        </ContextProviders>
      );
    },
  },
  {
    path: '/:partnerNumber',

    // keep in mind, routes are evaluated in order
    children: [
      home,
      profile,
      usersManagement,
      adminPartnerAccounts,
      adminGroupedOrders,
      adminGroupedOrderCreate,
      adminUsersManagement,
      articleList,
      space,
      fleetList,
      fleetInfo,
      manager,
      notifications,
      almanac,
      dailyNews,
      fictions,
      quiz,
      emag,
      calendar,
      partnerProfile,
      statistics,
    ],

    action: async (context: RouteContext) => {
      const component = await context.next();
      if (component === undefined) return component;
      const header = component.key !== 'login' && component.key !== 'docs';

      return (
        <ContextProviders apolloClient={apolloClient} context={context}>
          <App
            context={context}
            header={header}
            partnerNumber={context.params.partnerNumber}
          >
            {component}
          </App>
        </ContextProviders>
      );
    },
  },
  {
    path: '/',
    action: (context: RouteContext) => (
      <ContextProviders apolloClient={apolloClient} context={context}>
        <App context={context} withoutExtraProps>
          <div />
        </App>
      </ContextProviders>
    ),
  },
];

export default getRoutes;
